<template>
  <device-setups
      id="device-setups"
      :show-device-name="true"
      :entity="{ model: 'customers', id: customerId }" />
</template>

<script>
import DeviceSetups from "@/containers/Customer/Devices/Setups/DeviceSetups";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: accountGetters } = h("db/account");

export default {
  name: "CustomerSetups",
  components: { DeviceSetups },
  computed: {
    ...accountGetters(["customerId"]),
  },
};
</script>

<style lang="css"></style>
